import { MutationFunction } from '@apollo/client';
import { message } from 'antd';
import {
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1PdfFileCreateAuthHeaderMutation,
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1ImageFileCreateAuthHeaderMutation,
  SendReportCaseV1BlobFileInput
} from '../../../../../../generated';
import { AuthResult } from '../../../../../shared/file-upload/azure-upload';

export const GetSendReportAuthHeader = async (
  caseId: string,
  fileData: File,
  filename: string,
  getAuthHeaderForPdfFile: MutationFunction<
    CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1PdfFileCreateAuthHeaderMutation,
    { input: SendReportCaseV1BlobFileInput }
  >,
  getAuthHeaderForImageFile: MutationFunction<
    CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1ImageFileCreateAuthHeaderMutation,
    { input: SendReportCaseV1BlobFileInput }
  >
): Promise<AuthResult> => {
  if (fileData.type === 'application/pdf') {
    return getAuthHeaderForPdfFile({
      variables: {
        input: {
          caseId,
          fileName: filename,
          contentType: fileData.type,
          contentLength: fileData.size
        }
      }
    })
      .then((response) => {
        return {
          ...response?.data?.sendReportCaseV1PdfFileCreateAuthHeader,
          ...{ isAuthorized: true }
        } as AuthResult;
      })
      .catch((error) => {
        console.error('Error uploading asset: ', error);
        message.error('Error getting authorization');
        return { isAuthorized: false } as AuthResult;
      });
  }

  return getAuthHeaderForImageFile({
    variables: {
      input: {
        caseId,
        fileName: filename.replace('.pdf', '-preview.png'),
        contentType: fileData.type,
        contentLength: fileData.size
      }
    }
  })
    .then((response) => {
      return {
        ...response?.data?.sendReportCaseV1ImageFileCreateAuthHeader,
        ...{ isAuthorized: true }
      } as AuthResult;
    })
    .catch((error) => {
      console.error('Error uploading asset: ', error);
      message.error('Error getting authorization');
      return { isAuthorized: false } as AuthResult;
    });
};
